import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from 'store';
import { sessionExpired } from 'store/auth/authSlice';
import { refreshAccessToken } from 'utils/authSession';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}api/`,
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.accessToken;
        headers.set('Content-Type', 'application/json');
        // If we have a token set in state, let's assume that we should be passing it.
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

// When the token has expired the backend answers 401. Try to get a new access
// token with the refresh token and retry the request once. If the refresh
// fails, clear the session so ProtectedRoutes redirects to the login page.
const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, apiCtx, extraOptions) => {
    let result = await rawBaseQuery(args, apiCtx, extraOptions);

    if (result.error?.status === 401 && (apiCtx.getState() as RootState).auth.accessToken) {
        const newAccessToken = await refreshAccessToken();

        if (newAccessToken) {
            // prepareHeaders reads the refreshed token from the store.
            result = await rawBaseQuery(args, apiCtx, extraOptions);
        }

        if (!newAccessToken || result.error?.status === 401) {
            apiCtx.dispatch(sessionExpired());
        }
    }

    return result;
};

export const api = createApi({
    baseQuery: baseQueryWithAuth,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    reducerPath: 'api',
    endpoints: () => ({}),
});
